<template>
    <el-dialog
        title="获取验证码"
        class="container"
        :visible.sync="dialogVisible"
        append-to-body
        width="500px"
    >
        <div class="body">
            <div class="img-area">
                <div class="img" @click="getValidateCode">
                    <img
                        :src="validateCodeSrc"
                        :style="{
                            backgroundImage: `url(${validateCodeSrc})`
                        }"
                    />
                </div>
                <span class="text" @click="getValidateCode">
                    看不清，换一张？
                </span>
            </div>
            <el-input
                size="large"
                v-model="code"
                placeholder="请输入图形验证码"
            ></el-input>
        </div>
        <div class="footer" slot="footer">
            <el-button class="btn cancel" @click="onCancel">取消</el-button>
            <el-button
                type="primary"
                class="btn submit"
                :loading="isLoading"
                :disabled="!code"
                @click="onSubmit"
                >确定</el-button
            >
        </div>
    </el-dialog>
</template>
<script>
import { v4 as uuidv4 } from 'uuid';
import { ApiGetGraphCode, ApiGetSmsCode } from '@/common/api';
export default {
    name: 'GraphCode',
    props: {
        phone: {
            type: [Number, String],
            default: ''
        },
        type: {
            type: String,
            default: ''
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        }
    },
    data() {
        return {
            code: '',
            validateCodeSrc: '',
            graphicCodeLoading: false, // 请求图形验证码的loading
            isLoading: false // 请求发送验证码的loading
        };
    },
    watch: {
        dialogVisible(val) {
            if (val) {
                this.getValidateCode();
            } else {
                Object.assign(this.$data, this.$options.data());
            }
        }
    },
    methods: {
        // 请求图形验证码
        getValidateCode() {
            if (this.graphicCodeLoading) return;
            this.graphicCodeLoading = true;
            const uuid = uuidv4();
            ApiGetGraphCode(uuid, this.type)
                .then(res => {
                    this.graphicCodeLoading = false;
                    return (
                        'data:image/png;base64,' +
                        btoa(
                            new Uint8Array(res.data).reduce(
                                (data, byte) =>
                                    data + String.fromCharCode(byte),
                                ''
                            )
                        )
                    );
                })
                .then(data => {
                    this.graphicCodeLoading = false;
                    this.validateCodeSrc = data;
                    this.loginuuid = uuid;
                })
                .catch(err => {
                    this.graphicCodeLoading = false;
                    this.$message.error(err.message || '获取图片验证码失败');
                });
        },
        onCancel() {
            this.$emit('update:visible', false);
        },
        onSubmit() {
            if (!this.code) return;
            this.isLoading = true;
            const obj = {
                code: this.code,
                uuid: this.loginuuid
            };
            if (this.phone) {
                obj.phone = this.phone;
            }
            // 获取验证码
            ApiGetSmsCode(obj, this.type)
                .then(res => {
                    const { success } = res;
                    this.isLoading = false;
                    if (success) {
                        this.$message({
                            message: '验证码发送成功',
                            duration: 1000,
                            type: 'success'
                        });
                        this.onCancel();
                        this.$emit('onOk');
                    }
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        onClear() {
            this.code = '';
        }
    }
};
</script>
<style lang="scss" scoped>
.container {
    ::v-deep {
        .el-dialog__body {
            padding: 0 20px;
        }
    }
    .body {
        .img-area {
            display: flex;
            margin-bottom: 14px;
        }
        .img {
            display: inline-block;
            width: 100px;
            height: 44px;
            margin-right: 4px;
            background: #d8d8d8;
            border-radius: 30px;
            user-select: none;
            cursor: pointer;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
                vertical-align: middle;
            }
        }
        .text {
            line-height: 40px;
            user-select: none;
            font-size: 12px;
            font-weight: 400;
            color: #186fff;
            -webkit-transition: all 0.2s;
            transition: all 0.2s;
            vertical-align: bottom;
        }
    }
}
</style>
